// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__khVMhCzD","warning":"SignUpIncorrectBirthStep_warning__revBT5rC","back":"SignUpIncorrectBirthStep_back__APPRIFxk"};